<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
  <main class="succes container" aria-labelledby="titre-succes">

    <h1 id="titre-succes">Achat terminé</h1>

    <p class="text-center my-3 fs-5" role="status">
      Merci pour votre achat
    </p>

    <p class="text-center">
      Votre commande numéro
      <strong>{{ route.query.numeroCommande }}</strong>
      a été enregistrée.
    </p>

    <section v-if="route.query.qrCodeUrl" aria-labelledby="titre-qr">

      <h2 id="titre-qr" class="visually-hidden">
        QR code de votre billet
      </h2>

      <p class="text-center">
        Un email vient de vous être envoyé contenant le QR code représentant votre ticket électronique.<br/>
        Conservez-le précieusement, vous devrez le présenter au conducteur lors de votre montée !
      </p>

      <img
        class="d-block mx-auto img-fluid"
        :src="route.query.qrCodeUrl"
        :alt="`QR code de la commande ${route.query.numeroCommande}`"
      />

    </section>

    <section v-else aria-labelledby="titre-confirmation">

      <h2 id="titre-confirmation" class="visually-hidden">
        Confirmation sans QR code
      </h2>

      <p class="text-center">
        Un email vient de vous être envoyé avec la confirmation de votre achat.
      </p>

    </section>

  </main>
</template>

<style scoped lang="scss">
@import "@/assets/main";

h1 {
  color: $firstcolor;
  text-align: center;
}
</style>
